module.exports = __webpack_public_path__ + "static/img/class_5.249be8a2.jpg";